module.exports = __webpack_public_path__ + "img/decline-selected.6743c30f.svg";